module.exports = __webpack_public_path__ + "static/img/01.e4dd854.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/front/threeD/9/01.png
// module id = QKOg
// module chunks = 2